export default __webpack_public_path__ + "static/media/iconPhone.54dc054e.png";